module.exports = __webpack_public_path__ + "i18n/ko_f411315c964341c126af7902f3ec9d1b.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 153